/**
 * System wishlist – localStorage, drawer z listą produktów (jak compare).
 */
(function () {
  const STORAGE_KEY = 'wings_wishlist';
  const MAX_ITEMS = 50;
  const t = function (key) { return (typeof window.wishlistDrawerTranslations !== 'undefined' && window.wishlistDrawerTranslations[key]) || ''; };

  function getRootUrl() {
    if (typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root) {
      return window.Shopify.routes.root;
    }
    const base = (typeof window.shopUrl !== 'undefined' ? window.shopUrl : window.location.origin) || '';
    return base ? base.replace(/\/?$/, '/') : '/';
  }

  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      const list = JSON.parse(raw);
      return Array.isArray(list) ? list.slice(0, MAX_ITEMS) : [];
    } catch (_) {
      return [];
    }
  }

  function setWishlist(handles) {
    const list = handles.slice(0, MAX_ITEMS);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
    dispatchWishlistUpdate();
  }

  function addToWishlist(handle) {
    if (!handle || typeof handle !== 'string') return false;
    const list = getWishlist();
    const normalized = handle.trim().toLowerCase();
    if (list.some(function (h) { return h.toLowerCase() === normalized; })) return true;
    setWishlist([...list, handle.trim()]);
    return true;
  }

  function removeFromWishlist(handle) {
    const list = getWishlist().filter(function (h) { return h.toLowerCase() !== String(handle).toLowerCase(); });
    setWishlist(list);
  }

  function dispatchWishlistUpdate() {
    window.dispatchEvent(new CustomEvent('wishlist-updated', { detail: { list: getWishlist() } }));
  }

  function updateHeaderCount() {
    const countEl = document.querySelector('[data-wishlist-count]');
    if (!countEl) return;
    const count = getWishlist().length;
    countEl.textContent = count;
    countEl.classList.toggle('hidden', count === 0);
    countEl.closest('.header__icon--wishlist')?.classList.toggle('has-count', count > 0);
  }

  function updateFloatingButton() {
    const floatBtn = document.querySelector('[data-wishlist-float]');
    if (!floatBtn) return;
    const count = getWishlist().length;
    const countEl = floatBtn.querySelector('[data-wishlist-float-count]');
    if (countEl) {
      countEl.textContent = count;
      countEl.classList.toggle('hidden', count === 0);
    }
    floatBtn.classList.toggle('is-visible', count > 0);
  }

  function fetchProduct(handle) {
    const root = getRootUrl().replace(/\/?$/, '');
    const sectionUrl = root + '/products/' + encodeURIComponent(handle) + '?section_id=product_compare_data';
    return fetch(sectionUrl)
      .then(function (res) {
        if (!res.ok) throw new Error('Product not found');
        return res.text();
      })
      .then(function (html) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const script = doc.querySelector('script[data-product-compare-json]');
        if (script && script.textContent) {
          try {
            return JSON.parse(script.textContent.trim());
          } catch (_) {}
        }
        throw new Error('No data');
      })
      .catch(function () {
        return fetch(root + '/products/' + encodeURIComponent(handle) + '.js').then(function (res) {
          if (!res.ok) throw new Error('Product not found');
          return res.json();
        }).then(function (data) {
          if (data && data.variants && data.variants.length && !data.variant_id) {
            var v = data.variants.find(function (x) { return x.available; }) || data.variants[0];
            if (v && v.id) data.variant_id = v.id;
          }
          return data;
        });
      });
  }

  // Prices come back from the Ajax API in the customer's presentment currency,
  // so they must be formatted in that currency too — see assets/wings-money.js.
  var moneyFormatter = null;
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '–';
    if (!moneyFormatter) {
      moneyFormatter = (window.WingsMoney && window.WingsMoney.formatterFor(document.getElementById('WishlistDrawer')))
        || function (c) { return ((Number(c) || 0) / 100).toFixed(2); };
    }
    return moneyFormatter(cents);
  }

  function getFeaturedImageUrl(p) {
    const img = p && p.featured_image;
    if (!img) return '';
    return typeof img === 'string' ? img : (img.src || img.url || '');
  }

  function escapeHtml(str) {
    if (str == null) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function getProductUrl(p) {
    if (!p || !p.url) return '#';
    var root = getRootUrl().replace(/\/?$/, '');
    return p.url.startsWith('http') ? p.url : root + (p.url.startsWith('/') ? p.url : '/' + p.url);
  }

  function renderWishlistItems(products, container) {
    if (!container) return;
    if (!products.length) {
      container.innerHTML = '';
      return;
    }
    var html = '<ul class="wishlist-drawer__list">';
    products.forEach(function (p) {
      var imgUrl = getFeaturedImageUrl(p);
      var url = getProductUrl(p);
      var title = escapeHtml(p.title || t('product_fallback') || 'Product');
      var price = formatMoney(p.price);
      var handle = escapeHtml(p.handle || '');
      html += '<li class="wishlist-drawer__item" data-product-handle="' + handle + '">';
      html += '<a href="' + escapeHtml(url) + '" class="wishlist-drawer__item-link">';
      html += '<span class="wishlist-drawer__item-image">';
      if (imgUrl) html += '<img src="' + escapeHtml(imgUrl) + '" alt="" loading="lazy" class="wishlist-drawer__item-img">';
      else html += '<span class="wishlist-drawer__item-placeholder"></span>';
      html += '</span>';
      html += '<span class="wishlist-drawer__item-info">';
      html += '<span class="wishlist-drawer__item-title">' + title + '</span>';
      html += '<span class="wishlist-drawer__item-price">' + price + '</span>';
      html += '</span>';
      html += '</a>';
      var vid = p.variant_id || (p.variants && p.variants[0] && p.variants[0].id);
      var available = p.available !== false;
      if (vid && available) {
        html += '<button type="button" class="wishlist-drawer__item-atc" aria-label="' + escapeHtml(t('add_to_cart_aria') || 'Dodaj do koszyka') + '" data-wishlist-atc data-variant-id="' + escapeHtml(String(vid)) + '" data-product-url="' + escapeHtml(url) + '">';
        html += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M16 10a4 4 0 0 1-8 0"/><path d="M3.103 6.034h17.794"/><path d="M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z"/></svg>';
        html += '</button>';
      }
      html += '<button type="button" class="wishlist-drawer__item-remove" aria-label="' + escapeHtml(t('remove_aria')) + '" data-wishlist-remove data-product-handle="' + handle + '">';
      html += '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>';
      html += '</button>';
      html += '</li>';
    });
    html += '</ul>';
    container.innerHTML = html;
  }

  function openDrawer() {
    var drawer = document.querySelector('wishlist-drawer');
    if (!drawer) return;
    var list = getWishlist();
    var emptyEl = drawer.querySelector('[data-wishlist-empty]');
    var bodyEl = drawer.querySelector('[data-wishlist-body]');
    var listEl = drawer.querySelector('[data-wishlist-list]');
    var clearEl = drawer.querySelector('[data-wishlist-clear]');
    if (emptyEl) emptyEl.classList.toggle('hidden', list.length > 0);
    if (bodyEl) bodyEl.classList.toggle('hidden', list.length === 0);
    if (clearEl) clearEl.classList.toggle('hidden', list.length === 0);
    if (list.length === 0) {
      drawer.open();
      return;
    }
    var loadingEl = drawer.querySelector('[data-wishlist-loading]');
    if (loadingEl) loadingEl.classList.remove('hidden');
    if (listEl) listEl.innerHTML = '';
    Promise.all(list.map(function (h) { return fetchProduct(h); }))
      .then(function (results) {
        var products = results.filter(Boolean);
        renderWishlistItems(products, listEl);
      })
      .catch(function () {
        if (listEl) listEl.innerHTML = '<p class="wishlist-drawer__error">' + escapeHtml(t('load_error')) + '</p>';
      })
      .finally(function () {
        if (loadingEl) loadingEl.classList.add('hidden');
      });
    drawer.open();
  }

  function initDrawer() {
    var drawer = document.querySelector('wishlist-drawer');
    if (!drawer) return;
    var closeBtn = drawer.querySelector('[data-wishlist-close]');
    var overlay = drawer.querySelector('[data-wishlist-overlay]');
    if (closeBtn) closeBtn.addEventListener('click', function () { drawer.close(); });
    if (overlay) overlay.addEventListener('click', function () { drawer.close(); });
    document.addEventListener('keydown', function (e) {
      if (e.code === 'Escape' && drawer.classList.contains('active')) drawer.close();
    });
  }

  function isInWishlist(handle) {
    if (!handle) return false;
    var list = getWishlist();
    var normalized = String(handle).trim().toLowerCase();
    return list.some(function (h) { return h.toLowerCase() === normalized; });
  }

  function updateWishlistButtonStates() {
    var list = getWishlist();
    var normalizedList = list.map(function (h) { return h.toLowerCase(); });
    document.querySelectorAll('[data-wishlist-add]').forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle') || btn.getAttribute('data-wishlist-add');
      if (!handle) return;
      var inList = normalizedList.indexOf(handle.trim().toLowerCase()) !== -1;
      btn.classList.toggle('is-in-wishlist', inList);
    });
  }

  function initAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-add]');
      if (!btn) return;
      e.preventDefault();
      var handle = btn.getAttribute('data-product-handle') || btn.getAttribute('data-wishlist-add');
      if (!handle) return;
      if (isInWishlist(handle)) {
        removeFromWishlist(handle);
      } else {
        addToWishlist(handle);
      }
    });
  }

  function initRemoveButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-remove]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-product-handle');
      if (!handle) return;
      removeFromWishlist(handle);
      var item = btn.closest('.wishlist-drawer__item');
      if (item) item.remove();
      var listEl = document.querySelector('[data-wishlist-list]');
      if (listEl && !listEl.querySelector('.wishlist-drawer__item')) {
        var drawer = document.querySelector('wishlist-drawer');
        if (drawer) {
          var emptyEl = drawer.querySelector('[data-wishlist-empty]');
          var bodyEl = drawer.querySelector('[data-wishlist-body]');
          var clearEl = drawer.querySelector('[data-wishlist-clear]');
          if (emptyEl) emptyEl.classList.remove('hidden');
          if (bodyEl) bodyEl.classList.add('hidden');
          if (clearEl) clearEl.classList.add('hidden');
        }
      }
    });
  }

  function initFloatingButton() {
    var floatBtn = document.querySelector('[data-wishlist-float]');
    if (!floatBtn) return;
    floatBtn.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  function initHeaderTrigger() {
    var trigger = document.querySelector('[data-wishlist-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function (e) {
      e.preventDefault();
      openDrawer();
    });
  }

  function initClearButton() {
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-wishlist-clear]')) return;
      setWishlist([]);
      var drawer = document.querySelector('wishlist-drawer');
      if (!drawer) return;
      var emptyEl = drawer.querySelector('[data-wishlist-empty]');
      var bodyEl = drawer.querySelector('[data-wishlist-body]');
      var listEl = drawer.querySelector('[data-wishlist-list]');
      var clearEl = drawer.querySelector('[data-wishlist-clear]');
      if (emptyEl) emptyEl.classList.remove('hidden');
      if (bodyEl) bodyEl.classList.add('hidden');
      if (clearEl) clearEl.classList.add('hidden');
      if (listEl) listEl.innerHTML = '';
    });
  }

  function refreshCartDrawerContent() {
    var cart = document.querySelector('cart-drawer');
    if (!cart) return Promise.resolve();
    var cartUrl = (typeof routes !== 'undefined' && routes.cart_url) ? routes.cart_url : '/cart';
    return fetch(cartUrl + '?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var selectors = ['cart-drawer-items', '.cart-drawer__footer'];
        for (var i = 0; i < selectors.length; i++) {
          var target = document.querySelector(selectors[i]);
          var source = doc.querySelector(selectors[i]);
          if (target && source) target.replaceWith(source);
        }
        var bubble = doc.querySelector('#cart-icon-bubble');
        var bubbleTarget = document.getElementById('cart-icon-bubble');
        if (bubble && bubbleTarget) bubbleTarget.innerHTML = bubble.innerHTML;
        var newCartDrawer = doc.querySelector('cart-drawer');
        if (cart && newCartDrawer && !newCartDrawer.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
          var emptyBlock = document.querySelector('.drawer__inner-empty.cart-drawer__empty');
          if (emptyBlock) emptyBlock.style.display = 'none';
        }
      })
      .catch(function () {});
  }

  function initWishlistAtc() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-wishlist-atc]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var cartAddUrl = (typeof window.routes !== 'undefined' && window.routes.cart_add_url) ? window.routes.cart_add_url : '/cart/add.js';
      var formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', '1');
      if (cart && typeof cart.getSectionsToRender === 'function') {
        var sections = cart.getSectionsToRender().map(function (s) { return s.id || s.section; });
        formData.append('sections', Array.isArray(sections) ? sections.join(',') : sections);
        formData.append('sections_url', window.location.pathname);
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(btn);
      }
      var config = (typeof fetchConfig === 'function') ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/json' } };
      config.headers = config.headers || {};
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      btn.disabled = true;
      btn.classList.add('loading');
      fetch(cartAddUrl, config)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data && data.status) {
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartError) {
              publish(PUB_SUB_EVENTS.cartError, { source: 'wishlist-drawer', message: data.description || data.message });
            }
            if (typeof alert !== 'undefined') alert(data.description || data.message || 'Nie udało się dodać do koszyka.');
            return;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist-drawer', productVariantId: variantId, cartData: data });
          }
          refreshCartDrawerContent().then(function () {
            if (cart) {
              if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
              if (typeof cart.open === 'function') cart.open();
            }
            var wishlistDrawer = document.querySelector('wishlist-drawer');
            if (wishlistDrawer && typeof wishlistDrawer.close === 'function') {
              setTimeout(function () { wishlistDrawer.close(); }, 60);
            }
          });
        })
        .catch(function () {
          if (typeof alert !== 'undefined') alert('Nie udało się dodać do koszyka.');
        })
        .finally(function () {
          btn.disabled = false;
          btn.classList.remove('loading');
        });
    });
  }

  customElements.define('wishlist-drawer', class WishlistDrawer extends HTMLElement {
    open() {
      this.classList.add('active');
      document.body.classList.add('overflow-hidden');
    }
    close() {
      this.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  });

  window.addEventListener('wishlist-updated', function () {
    updateHeaderCount();
    updateFloatingButton();
    updateWishlistButtonStates();
  });

  document.addEventListener('DOMContentLoaded', function () {
    updateHeaderCount();
    updateFloatingButton();
    updateWishlistButtonStates();
    initDrawer();
    initAddButtons();
    initRemoveButtons();
    initFloatingButton();
    initHeaderTrigger();
    initClearButton();
    initWishlistAtc();
  });

  window.Wishlist = {
    getList: getWishlist,
    add: addToWishlist,
    remove: removeFromWishlist,
    openDrawer: openDrawer
  };
})();